(function () {
  var rootSelector = '.MM-faq-V1';
  var boundFlag = 'data-mm-faq-v1-js';
  var instances = new WeakMap();

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getPanelHeight(panel) {
    return panel.scrollHeight;
  }

  function setExpanded(item, expanded, animate) {
    var trigger = item.querySelector('[data-mm-faq-v1-trigger]');
    var panel = item.querySelector('[data-mm-faq-v1-panel]');

    if (!trigger || !panel) return;

    item.classList.toggle('is-open', expanded);
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');

    if (!animate || prefersReducedMotion()) {
      panel.style.height = expanded ? 'auto' : '0px';
      return;
    }

    if (expanded) {
      panel.style.height = '0px';
      panel.offsetHeight;
      panel.style.height = getPanelHeight(panel) + 'px';
      return;
    }

    panel.style.height = getPanelHeight(panel) + 'px';
    panel.offsetHeight;
    panel.style.height = '0px';
  }

  function closeItem(item, animate) {
    if (!item || !item.classList.contains('is-open')) return;
    setExpanded(item, false, animate);
  }

  function openItem(item, animate) {
    if (!item) return;
    setExpanded(item, true, animate);
  }

  function destroy(root) {
    var instance = instances.get(root);
    if (!instance) return;

    instance.triggers.forEach(function (trigger) {
      trigger.removeEventListener('click', instance.onTriggerClick);
    });

    instance.panels.forEach(function (panel) {
      panel.removeEventListener('transitionend', instance.onTransitionEnd);
    });

    instances.delete(root);
  }

  function init(root) {
    if (!root) return;

    destroy(root);

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mm-faq-v1-item]'));
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-mm-faq-v1-trigger]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-mm-faq-v1-panel]'));

    if (triggers.length === 0) return;

    var onTriggerClick = function (event) {
      var trigger = event.currentTarget;
      var item = trigger.closest('[data-mm-faq-v1-item]');
      if (!item || !root.contains(item)) return;

      var isOpen = item.classList.contains('is-open');

      items.forEach(function (otherItem) {
        if (otherItem !== item) closeItem(otherItem, true);
      });

      if (isOpen) {
        closeItem(item, true);
      } else {
        openItem(item, true);
      }
    };

    var onTransitionEnd = function (event) {
      if (event.propertyName !== 'height') return;
      var panel = event.currentTarget;
      var item = panel.closest('[data-mm-faq-v1-item]');
      if (!item || !item.classList.contains('is-open')) return;
      panel.style.height = 'auto';
    };

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', onTriggerClick);
    });

    panels.forEach(function (panel) {
      panel.addEventListener('transitionend', onTransitionEnd);
      panel.style.height = '0px';
    });

    instances.set(root, {
      triggers: triggers,
      panels: panels,
      onTriggerClick: onTriggerClick,
      onTransitionEnd: onTransitionEnd
    });
  }

  function findRoot(target) {
    if (!target) return null;
    if (target.matches && target.matches(rootSelector)) return target;
    if (target.querySelector) return target.querySelector(rootSelector);
    return null;
  }

  function initAll() {
    document.querySelectorAll(rootSelector).forEach(init);
  }

  if (document.documentElement.getAttribute(boundFlag) !== 'true') {
    document.documentElement.setAttribute(boundFlag, 'true');

    document.addEventListener('shopify:section:load', function (event) {
      init(findRoot(event.target));
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = findRoot(event.target);
      if (root) destroy(root);
    });

    document.addEventListener('shopify:block:select', function (event) {
      var item = event.target && event.target.closest ? event.target.closest('[data-mm-faq-v1-item]') : null;
      var root = item ? item.closest(rootSelector) : null;
      if (!root || !item || !item.querySelector('[data-mm-faq-v1-trigger]')) return;

      Array.prototype.slice.call(root.querySelectorAll('[data-mm-faq-v1-item]')).forEach(function (otherItem) {
        if (otherItem !== item) closeItem(otherItem, false);
      });

      openItem(item, false);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  } else {
    initAll();
  }
})();
